// extracted by mini-css-extract-plugin
module.exports = {"m1pfqqqx":"m1pfqqqx","desktop-cover-overlay":"desktop-cover-overlay","cls5y7s":"cls5y7s","t1i66t6f":"t1i66t6f","LiTV":"LiTV","cgeqbr3":"cgeqbr3","nru1ju8":"nru1ju8"};